export default __webpack_public_path__ + "static/media/heroback.ed116538.png";